import { Box, Typography } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import CustomButton from '../global/CustomButton';

const RevokeCredentials = ({ onConfirm, onCancel, loading }) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      gap={2}
      p={2}
    >
      <Typography fontSize={'13px'} gutterBottom>
        {loading
          ? 'Revoking credentials, please wait...'
          : 'Do you really want to revoke the credentials?'}
      </Typography>

      <Box display="flex" gap={2}>
        <CustomButton
          onClick={onConfirm}
          color={'lRed'}
          sx={{ width: '100px' }}
          icon={CheckCircleIcon}
          buttonText={loading ? 'Revoking...' : 'Yes'}
          disabled={loading}
        />
        <CustomButton
          onClick={onCancel}
          color={'black'}
          sx={{ width: '100px' }}
          icon={CancelIcon}
          buttonText={'No'}
          disabled={loading}
        />
      </Box>
    </Box>
  );
};

export default RevokeCredentials;
